module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Basse-Vendline_COA-6dd8e6f38c6f73578e1e0d9e3a1bee63.svg";